import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {CookieWebuUtil} from '@webu/data';
import {Subject, Subscription, takeUntil, tap} from 'rxjs';
import {AppConfigService, SessionStorageService, AutoDestroy} from '@ox/utils';

import {
  selectActiveVehicle,
  selectProfile,
  OvdService,
  GarageService
} from '@ox/data';

import {
  Brands,
  ExpandCollection,
  GfasPayload,
  Profile,
  PhoneNumber,
  Vehicle,
  Window
} from '@ox/typings';
import {Store} from '@ngrx/store';

const AUTH = 'authenticated';
const UNAUTH = 'unauthenticated';

type unauth = typeof UNAUTH;
type auth = typeof AUTH;
type UserState = auth | unauth;

const ADDMILEAGECLICKED = 'addMileageClicked';
const UPDATEMILEAGECLICKED = 'updateMileageClicked';
const ADDMILEAGE = 'addMileage';
const UPDATEMILEAGE = 'updateMileage';

type addMileageClicked = typeof ADDMILEAGECLICKED;
type updateMileageClicked = typeof UPDATEMILEAGECLICKED;
type addMileage = typeof ADDMILEAGE;
type updateMileage = typeof UPDATEMILEAGE;

type activeVehicleMileageState =
  | addMileageClicked
  | updateMileageClicked
  | addMileage
  | updateMileage;

@Component({
  selector: 'webu-vehicle-snapshot',
  templateUrl: './vehicle-snapshot.component.html'
})
export class VehicleSnapshotComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() formattedDate: string;
  @Input() loading: boolean;
  @Input() isOnstarActive: boolean;
  @Input() profile: Profile | undefined;
  @Input() userState: auth | unauth;


  @Input() successMessage:string;
  @Output() successMessageChange = new EventEmitter<string>();

  @Input() activeVehicleMileageState: string;

  @Output() activeVehicleMileageStateChange = new EventEmitter<string>();

  public activeVehicle$ = this.store.select(selectActiveVehicle)
    .pipe(
      takeUntil(this.destroy$),
      tap((vehicle) => {
        if (vehicle) {
          this.activeVehicle = vehicle;
        }
      })
    ).subscribe();

  private _activeVehicle: Vehicle;

  get activeVehicle() {
    return this._activeVehicle;
  }

  set activeVehicle(vehicle) {
    this._activeVehicle = vehicle;
  }

  // public loading: boolean;
  public language: string;
  public profileId: any;
  //public activeVehicleMileageState: string;
  showAddMileageButton: boolean;
  showMileageUpdateLink: boolean;
  showAddMileageLink: boolean;
  dateFormat: any = this.appConfig.appSettings.moduleConfig.dateFormat;
  hasOdometerReading: boolean;
  odometerLastUpdated: string;
  public flag = {
    invalidMileageError: false,
    updateMileageError: false
  };
  constructor(
    private store: Store,
    private appConfig: AppConfigService,
    private SessionStorageService: SessionStorageService,
    private _OvdService: OvdService,
    private garageService: GarageService
  ) {}

  ngOnInit(): void {
    this.language = window.gm.bml?.lang;
    this.setActiveVehicleAttributes();
  }



  setActiveVehicleAttributes(): void {
    if (this.activeVehicle) {
      if (
        isNaN(Number(this.activeVehicle.odometer)) ||
        Number(this.activeVehicle.odometer) === 0
      ) {
        this.activeVehicleMileageState = ADDMILEAGE;
        this.showMileageUpdateLink = false;
        this.showAddMileageLink = true;
      } else {
        this.activeVehicleMileageState = UPDATEMILEAGE;
        this.showMileageUpdateLink = true;
        this.showAddMileageLink = false;
        this.odometerLastUpdated = String(
          this.activeVehicle.odometerLastUpdated
        );

        // Might not need hasOdometerReading...
        this.hasOdometerReading = true;
      }
      this.loading = false;
    }
  }

  goToAddMileageTemplate = () => {
    this.activeVehicleMileageState = ADDMILEAGECLICKED;
    this.activeVehicleMileageStateChange.emit(ADDMILEAGECLICKED);
  };

  goToUpdateMileageTemplate = () => {
    this.activeVehicleMileageState = UPDATEMILEAGECLICKED;
    this.activeVehicleMileageStateChange.emit(UPDATEMILEAGECLICKED);
  };

  public vehicleMileageUpdate(event:any) {
    if (this.profile) {
      this.garageService.updateVehicleMileage(
        this.profile.profileId,
        {...this.activeVehicle, odometer: event.odometer, odometerLastUpdated: Date.now()}).subscribe({
          next: () => {
            this.flag.updateMileageError = false;
            this.activeVehicleMileageState = UPDATEMILEAGE;
            this.successMessageChange.emit(event.message);
          },
          error: (e) => {
            this.flag.updateMileageError = true;
            console.warn(`Error updating mileage: ${e}`);
          }
        });
    }
  }

}
